module.exports = __webpack_public_path__ + "img/edit-icon.6647ba6c.svg";